export enum BlockchainNetwork {
  btc = 'btc' as any,
  tbtc = 'tbtc' as any,
  bch = 'bch' as any,
  tbch = 'tbch' as any
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/shared/blockchain-network.model.ts